<script lang="ts">
    import type { State } from '../../types/State'

    import type { Subsection } from '../../types/Subsection'
    import { Formatter } from '../../util/Formatter'
    import Statement from './Statement.svelte'

    export let path: [number, number, number]

    export let state: State

    export let subsection: Subsection

    export let simpleLanguage = false
</script>

<div class="table-containter" class:simple-language={simpleLanguage}>
    <table>
        <thead>
            <tr>
                <th colspan="2">
                    <div>
                        {#if !simpleLanguage}
                            <span>
                                {path.map((it) => it + 1).join('.')}
                            </span>
                        {/if}
                        {@html Formatter.convertLineBreaksToHTML(subsection.description)}
                    </div>
                </th>
                <th>Ja</th>
                <th>Eher Ja</th>
                <th>Eher Nein</th>
                <th>Nein</th>
                <th>
                    {#if simpleLanguage}
                        Weiß ich nicht
                    {:else}
                        Nicht relevant
                    {/if}
                </th>
            </tr>
        </thead>
        {#each subsection.statements as statement, index}
            <Statement
                bind:statement
                path={[...path, index]}
                showLetter={subsection.statements.length > 1}
                bind:state
                {simpleLanguage}
            />
        {/each}
    </table>
</div>

<style lang="scss">
    .table-containter {
        padding-bottom: 2rem;
        box-shadow: 0 4px 24px 0 rgba(18, 20, 25, 0.08);
        border-radius: 0.3125rem;
        margin-bottom: 7rem;
        width: 100%;

        @media (min-width: 790px) {
            padding-bottom: 0;
        }

        table {
            border-collapse: collapse;
        }

        &.simple-language {
            font-size: 1.25rem;
        }
    }

    thead {
    }

    th {
        background-color: var(--color-surface);
        color: var(--color-primary);
        padding-top: 2rem;
        padding-bottom: 1rem;
        padding-left: 1rem;
        padding-right: 1rem;
        vertical-align: top;
        font-weight: 400;
        color: var(--color-text);
        width: 100%;

        &:nth-child(1) {
            border-top-left-radius: 0.3125rem;

            div {
                color: var(--color-primary);
                font-size: 1.5rem;
                text-align: left;
                display: flex;
                column-gap: 1rem;
                align-items: flex-start;
                font-weight: 600;
                hyphens: auto;
            }

            span {
                background-color: var(--color-primary);
                border-radius: 0.3125rem;
                color: #ffffff;
                padding: 8px;
                line-height: 1;
            }
        }

        &:last-child {
            border-top-right-radius: 0.3125rem;
        }
    }

    @media (max-width: 790px) {
        tr {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }
        th {
            display: none;
            box-sizing: border-box;

            &:first-child {
                width: 3rem;
                display: block;
            }

            &:nth-child(1) {
                width: 100%;
                display: block;
            }
        }
    }
</style>
